import styled from "styled-components";
interface IProps {
  isArabic?: boolean;
}
export const InnerPage = styled("div")`
background: #fff;
margin: 0 auto;
position: relative;
z-index: 1;
max-width: 950px;
// padding: 16px 10px 0;
font-size: 62.5%;
`;
export const GridSkin = styled("div")`
    padding: 0 0 36px;
    max-width: 950px;
`;
export const ContainerStyle01 = styled("div")`
width: 100%;
float: left;
padding-top: 12px;
`
export const ButtonDiv  = styled("div")`
height: 70px;
`

export const ConfirmMsg = styled("div")`
padding-top: 19px;
padding-bottom: 10px;
min-height: 190px;
border-bottom: 1px solid #e5e5e5;
`;
export const ConfirmationMsg = styled.div<IProps>`
padding-top: 10px;
text-align: ${(p) => (p.isArabic? `right`:`left`)};
p{
  line-height: 1.2;
  padding-top: 20px;
  color: #4c4c4c;
  font-size: 14px;
  font-family: Arial, Helvetica, sans-serif;
  display: block;
}
`;
export const ConfirmationMsg1 = styled.div<IProps>`
padding-top: 10px;
display: block;
text-align: ${(p) => (p.isArabic? `right`:`left`)};

`;


export const NoLine = styled("h3")`
text-align:"left";
font-size: 1.8em;
font-weight: normal;
padding-bottom: 12px;
line-height: 28px;
border-bottom: 1px solid #d0d0d0;
font-family: Arial, Helvetica, sans-serif;
color:black;
display: block;
margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;

`;
   
export const RowButton=styled("div")`
margin:auto;
display: flow-root;    
padding: 0px 0 20px;
`
export const ErrorMsgDiv=styled("div")`
padding-bottom: 15px;
width: 100%;
position: relative;
display: block;
`

export const HeadingContent = styled("div")`
    margin-top: 10px;
    display: block;
    background-color: #f8f8f8;
    padding: 7px 0 3px;
`;

export const PageHeadingInner = styled("div")`
// max-width: 950px;
margin-right: auto;
margin-left: auto;

@media only screen and (max-width: 1024px) {
  max-width: calc(100% - 68px);
  padding: 0 30px;
}

@media only screen and (max-width: 768px) {
  max-width: calc(100% - 38px);
  padding: 0 18px;
}

@media only screen and (max-width: 414px) {
  max-width: 100%;
  padding: 0 18px;
}

h2{
  font-size: 1.5em;
  font-weight: normal;
  line-height: 1em;
  font-family: Arial, Helvetica, sans-serif;
  display: block;
  color:black;
  margin: 0 auto;
  padding-bottom: 12px;
}
`;
